import { getForm } from '@wix/ambassador-forms-v4-form/http';
import { getFieldPropertiesByTarget as _getFieldPropertiesByTarget } from '@wix/form-schema';
async function fetchFormSchema({ formId, httpClient, }) {
    try {
        const response = await httpClient.request(getForm({
            formId,
        }));
        return response.data.form;
    }
    catch (e) {
        console.error('Failed to load form to check isFormEmpty');
        return undefined;
    }
}
export function isEmpty(form) {
    if (!form.fields) {
        return true;
    }
    return form.fields.filter((f) => !f.hidden).length === 0;
}
export function isFormEmptyBuilder(formsById) {
    return function (formId) {
        const form = formsById[formId];
        if (!form) {
            return null;
        }
        return isEmpty(form);
    };
}
export async function isFormEmpty({ httpClient, formId, }) {
    const form = await fetchFormSchema({
        formId,
        httpClient,
    });
    if (form === undefined) {
        return null;
    }
    return isEmpty(form);
}
export async function getFieldPropertiesByTarget({ httpClient, formId, options, }) {
    const form = await fetchFormSchema({
        formId,
        httpClient,
    });
    if (form === undefined) {
        return undefined;
    }
    return _getFieldPropertiesByTarget(form, options);
}
//# sourceMappingURL=form-utils.js.map